import { SET_INITIALIZE_SUCCESS } from "../../../components/VisaApplicationChoice/action";

import {
  OFLC_CASE_DELETE_SUCCESS,
  OFLC_CASE_UPDATE_SUCCESS,
  OFLC_CASE_UPDATE_FAILURE,
  OFLC_SUBMIT_CASE_SUCCESS,
  OFLC_SUBMIT_CASE_FAILURE,
  CLEAR_STATUS_MODAL
} from "../../../components/Form/actions";

const initialState = {
  error: false,
  message: null,
  showModal: false
};

export default (state = initialState, actions) => {
  switch (actions.type) {
    case SET_INITIALIZE_SUCCESS:
      return {
        ...state,
        error: false
      };
    case OFLC_CASE_DELETE_SUCCESS:
      return {
        ...state,
        error: false
      };
    case OFLC_SUBMIT_CASE_SUCCESS:
      return {
        ...state,
        showModal: true,
        error: false
      };
    case OFLC_SUBMIT_CASE_FAILURE:
      return {
        ...state,
        error: true,
        showModal: true,
        message: actions.payload
      };
    case OFLC_CASE_UPDATE_SUCCESS:
      return {
        ...state,
        error: false
      };
    case OFLC_CASE_UPDATE_FAILURE:
      return {
        ...state,
        error: true
      };
    case CLEAR_STATUS_MODAL:
      return {
        ...state,
        error: false,
        showModal: false,
        message: null
      };
    default:
      return state;
  }
};
